import {
  Question,
  DynamicForm,
  QuestionDisposition,
} from './../../_models/dynamic-form.model';
import { DynamicFormAnswer } from './../../_models/dynamic-form-answer.model';
import { StorageService } from 'src/app/_services/storage.service';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { StateTransitionsModel } from 'src/app/_models/state-transitions.model';
import { DynamicFormService } from 'src/app/_services/dynamic-form.service';
import { Router } from '@angular/router';
import { ConfirmTransitionResponse } from 'src/app/_models/Confirm-transition-response.model';
import { AuthService } from 'src/app/_services/auth.service';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { error } from 'jquery';
import { RequiredDocuments } from 'src/app/_models/required-documents.model';
import { auditTime, Subscription } from 'rxjs';

declare var bootstrap: any;

@Component({
  selector: 'DCO-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  standalone: false,
})
export class DynamicFormComponent implements OnInit {
  //@ViewChild('f') myForm: NgForm;
  public myFormGroup!: FormGroup;
  @Input() fileRefs: {};
  @Input() formData: FormData;
  @Input() claimOperationIds: string[] = [];
  @Input() claimOperationId: string;
  @Input() isMassive: boolean;
  @Input() finalStateDyf: number;
  @Input() stateMasterId: number;
  @Input() dynamicFormId: number;
  @Input() requiredDocuments: RequiredDocuments[];
  @Input() comments: string;
  @Output() confirmDisputeEvent = new EventEmitter<boolean>();
  @Output() stateTransitionsResEvent = new EventEmitter<
    StateTransitionsModel[]
  >();
  showErrorValidation = false;
  showErrorConfirm = false;
  listErrorConfirm = [];
  confirmTransitionResponse: ConfirmTransitionResponse;
  confirmDisputP: boolean = true;
  dynamicForm: any;
  dynamicForm_Code: string;
  responses: Record<string, string> = {};
  dfError: boolean = false;
  loadCompleted: boolean = true;
  claimOperationIdF;
  stateTransitionsRes: StateTransitionsModel[];
  dynamicFormAnswers: DynamicFormAnswer[] = [];
  dynamicFormAnswersFinal: {} = {};
  tokenData: any;
  comprobation: boolean;
  blockButton: boolean = true;
  showRequiredDocuments: boolean = true;
  documentsRequired: boolean = false;

  constructor(
    private DynamicFormService: DynamicFormService,
    private StorageService: StorageService,
    public langService: LanguageManagerService,
    private router: Router,
    private authService: AuthService,
    private el: ElementRef,
  ) {}

  ngOnInit(): void {
    // console.log('dyf');
    //this.loadDynamicFormData();
    this.blockButton = false;
    this.showRequiredDocuments = false;
    this.documentsRequired = true;
    this.loadDynamicForm();
    this.tokenData = this.authService.getTokenData();
    //console.log(this.tokenData)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['documentAssignFileBase64']) {
      // console.log('slice', this.documentAssignFileBase64);
    }
  }

  keyToQuestionId = new Map<string, number>();
  private visibility = new Map<number, boolean>();
  private updatingVisibility = false;
  private formSub?: Subscription;

  loadDynamicForm() {
    this.loadCompleted = false;
    if (this.isMassive == true) {
      this.claimOperationIdF = this.claimOperationIds[0];
    } else {
      this.claimOperationIdF = this.claimOperationId;
    }

    this.DynamicFormService.GetDynamicForm(
      this.dynamicFormId,
      this.claimOperationIdF,
    ).subscribe({
      next: (response) => {
        this.dynamicForm = response.dynamicForm;
        this.dynamicTranslateDYF(this.dynamicForm);
        this.responses = response.dynamicForm['responseObject'];
        this.dynamicForm_Code = response.dynamicForm['code'];
        if (this.dfError == true) {
          this.dfError = false;
        }

        Object.entries(
          this.dynamicForm.questions as Record<string, string>,
        ).forEach(([idStr, key]) => {
          this.keyToQuestionId.set(key, Number(idStr));
        });

        const formControlsInFormGroup: Record<string, FormControl> = {};

        this.dynamicForm.sectionsDisposition[0].section.questionsDisposition.forEach(
          (questionDisposition: QuestionDisposition) => {
            const questionIdStr = questionDisposition.questionId.toString();
            const key = questionDisposition.question.keyName;

            // valor inicial: respuesta pasada o defaultValue
            const initialValue =
              this.responses[key] !== undefined && this.responses[key] !== null
                ? this.responses[key]
                : (questionDisposition.question.defaultValue ?? '');

            // antes add validadores aqui pero ahora llamamos a applyVisibilityRules
            formControlsInFormGroup[questionIdStr] = new FormControl(
              initialValue,
            );
          },
        );

        this.myFormGroup = new FormGroup(formControlsInFormGroup);
        this.applyVisibilityRules();

        // suscribimos el evento de cambios de valor en el form para que revise automáticamente las visibilidades
        this.formSub = this.myFormGroup.valueChanges
          .pipe(auditTime(0))
          .subscribe(() => {
            this.applyVisibilityRules();
          });
        // si todo es correcto mostramos el form
        this.loadCompleted = true;
        this.loadInfoForm()
      },

      // error: (error) => {
      //   console.error('Error fetching dynamic form data:', error);
      //   this.dfError = true;
      //   if (error.status == 401) {
      //     this.StorageService.clean();
      //     this.router.navigate(['/login']);
      //   }
      // },
    });
  }

  isVisible(questionId: number): boolean {
    // Si no hay regla, usa la visibilidad de questionDisposition (inicial) o true
    return this.visibility.get(questionId) ?? true;
  }
  isDocumentRequiredControl(label: string): boolean {
    return label.toLowerCase().endsWith('document_required');
  }

  firstLoad: boolean = true;
  private applyVisibilityRules(): void {
    if (this.updatingVisibility) return;
    this.updatingVisibility = true;

    const formValue = this.myFormGroup.getRawValue();

    // repasar las preguntas aplicando las reglas
    for (const sectionDisp of this.dynamicForm.sectionsDisposition) {
      for (const qDisp of sectionDisp.section
        .questionsDisposition as QuestionDisposition[]) {
        const qId = qDisp.questionId;
        const wasVisible = this.visibility.get(qId) ?? qDisp.visible ?? true;
        const nowVisible = this.checkQuestionVisibilityPure(qDisp, formValue);

        // Actualiza cache de visibilidad
        this.visibility.set(qId, nowVisible);

        // Ajusta validadores solo si cambia la visibilidad
        const control = this.myFormGroup.get(qId.toString());
        if (!control) continue;
        if (this.isDocumentRequiredControl(qDisp.question.lbl_LabelText)) {
          this.documentsRequired = !nowVisible;
        }
        // valida si ha cambiado la visibilidad para evitar recrear controles
        if (this.firstLoad || nowVisible !== wasVisible) {
          if (nowVisible) {
            const validators = this.getValidators(qDisp);
            control.setValidators(validators);
          } else {
            // si se oculta se quitan los validadores para evitar bloquear el proceso
            control.clearValidators();
            // actualmente no borramos el valor al ocultar, pero deberíamos revisar en el form,
            // si es invisible no se envía
            // control.setValue('', { emitEvent: false });
          }
          // Evita re-emisiones y bucles
          control.updateValueAndValidity({ emitEvent: false });
        } else {
          // Si no cambió visibilidad, evita reinstalar validadores cada vez
          // (nada que hacer aquí)
        }
      }
    }

    this.firstLoad = false;
    this.updatingVisibility = false;
  }

  private checkQuestionVisibilityPure(
    questionDisposition: QuestionDisposition,
    formValue: Record<string, any>,
  ): boolean {
    const question = questionDisposition.question;

    // Si no hay reglas, usa visibilidad del propio questionDisposition o true
    if (!question.ruleConditionStructureKeys) {
      return questionDisposition.visible ?? true;
    }

    const orConditions = question.ruleConditionStructureKeys.split('|');

    for (const condition of orConditions) {
      const andConditions = condition.split('&');
      const allAndConditionsMet = andConditions.every((cond) =>
        this.checkConditionPure(cond, formValue),
      );
      if (allAndConditionsMet) {
        return true;
      }
    }

    return false;
  }

  private checkConditionPure(
    condition: string,
    formValue: Record<string, any>,
  ): boolean {
    const [key, value] = condition.split('=');
    const qId = this.keyToQuestionId.get(key);
    if (qId === undefined) {
      // si no encontramos el id, intenta comparar contra responses antiguas
      return this.responses[key] === value;
    }
    return formValue[qId] === value;
  }

  private getValidators(questionDisposition: QuestionDisposition): any[] {
    const validators = [];

    // Required
    if (questionDisposition.question.rfv_RequiredFieldValidatorControl) {
      validators.push(Validators.required);
    }
    // MaxLength (si existe y > 0)
    const maxLen =
      typeof questionDisposition.question.maxLength === 'string'
        ? parseInt(questionDisposition.question.maxLength, 10)
        : questionDisposition.question.maxLength;

    if (maxLen && maxLen > 0) {
      validators.push(Validators.maxLength(maxLen));
    }

    // other validators go here numbers, dates, etc...

    return validators;
  }

  private controlTypeCache = new Map<
    number,
    { type: string; inputType: string }
  >();
  private optionsCache = new Map<
    number,
    Array<{ text: string; value: string }>
  >();

  getControlTypeCached(questionDisp: any): { type: string; inputType: string } {
    const id = questionDisp.questionId;
    const cached = this.controlTypeCache.get(id);
    if (cached) {
      return cached;
    }

    const controlType = (
      questionDisp.question.controlTypeName || ''
    ).toLowerCase();
    let type = 'default';
    let inputType = 'text';

    if (controlType.includes('dropdown')) {
      type = 'dropdown';
    } else if (controlType.includes('textboxnumeric')) {
      type = 'input';
      inputType = 'number';
    } else if (
      controlType.includes('datepicker') ||
      controlType.includes('raddatepicker')
    ) {
      type = 'input';
      inputType = 'date';
    } else if (controlType.includes('textbox')) {
      type = 'input';
      inputType = 'text';
    }

    const result = { type, inputType };
    this.controlTypeCache.set(id, result);
    return result;
  }

  getControlTypeOptionsCached(
    questionDisp: any,
  ): Array<{ text: string; value: string }> {
    const id = questionDisp.questionId;
    const cached = this.optionsCache.get(id);
    if (cached) {
      return cached;
    }

    const controlValue = questionDisp.question.controlValueString || '';
    const controlText = questionDisp.question.controlTextString || '';

    const valuesArray = controlValue.split('#').filter((s) => s !== '');
    const textArray = controlText.split('#').filter((s) => s !== '');

    const options = valuesArray.map((v, i) => ({
      value: v,
      text: textArray[i] ?? v,
    }));

    this.optionsCache.set(id, options);
    return options;
  }

  //Load the DynamiFormn data from DynamicFormService service
  loadDynamicFormData() {
    // console.log('dyf');
    this.loadCompleted = false;

    if (this.isMassive == true) {
      this.claimOperationIdF = this.claimOperationIds[0];
    } else {
      this.claimOperationIdF = this.claimOperationId;
    }

    // console.log(this.dynamicFormId);

    this.DynamicFormService.GetDynamicForm(
      this.dynamicFormId,
      this.claimOperationIdF,
    ).subscribe({
      next: (response) => {
        this.dynamicForm = response.dynamicForm;
        //console.log(this.dynamicForm);
        this.dynamicTranslateDYF(this.dynamicForm);
        //console.log(this.dynamicForm);
        this.responses = response.dynamicForm['responseObject'];
        this.dynamicForm_Code = response.dynamicForm['code'];
        if (this.dfError == true) {
          this.dfError = false;
        }
        this.loadCompleted = true;
        const formControlsInFormGroup: any = {};
        //this.myFormGroup = new FormGroup([]);

        // set validations
        response.dynamicForm.sectionsDisposition[0].section.questionsDisposition.map(
          (questionDisposition) => {
            let controlValidatorArray = this.GetValidators(questionDisposition);
            let formControl = new FormControl(
              questionDisposition.question.defaultValue,
              controlValidatorArray,
            );
            formControlsInFormGroup[questionDisposition.questionId.toString()] =
              formControl;
          },
        );
        this.myFormGroup = new FormGroup(formControlsInFormGroup);
      },

      // error: (error) => {
      //   console.error('Error fetching dynamic form data:', error);
      //   this.dfError = true;
      //   if (error.status == 401) {
      //     this.StorageService.clean();
      //     this.router.navigate(['/login']);
      //   }
      // },
    });
  }
  // checks de question and sets the validators
  private GetValidators(questionDisposition: QuestionDisposition): any[] {
    let controlValidatorArray = [];
    if (
      questionDisposition.visible &&
      questionDisposition.question.rfv_RequiredFieldValidatorControl
    ) {
      controlValidatorArray.push(Validators.required);
    }
    if (
      questionDisposition.visible &&
      questionDisposition.question.maxLength &&
      questionDisposition.question.maxLength > 0
    ) {
      controlValidatorArray.push(
        Validators.maxLength(questionDisposition.question.maxLength),
      );
    }
    return controlValidatorArray;
  }
  //Determine(dinamically) the input type to be rendered in the form based on `controlTypeName`
  getControlType(questionDisp: any): { type: string; inputType: string } {
    const controlType = questionDisp.question.controlTypeName.toLowerCase();
    let type = 'default';
    let inputType = 'text';

    if (controlType.includes('dropdown')) {
      type = 'dropdown';
    } else if (controlType.includes('textboxnumeric')) {
      type = 'input';
      inputType = 'number';
    } else if (controlType.includes('datepicker')) {
      type = 'input';
      inputType = 'date';
    } else if (controlType.includes('textbox')) {
      type = 'input';
      inputType = 'text';
    }

    return { type, inputType };
  }

  //transform the value and text string to a iterable structure to be the options list into dropdown
  getControlTypeOptions(questionDisp: any): any[] {
    const controlValue = questionDisp.question.controlValueString;
    const controlText = questionDisp.question.controlTextString;

    if (controlValue && controlText) {
      const valuesArray = controlValue.split('#');
      const textArray = controlText.split('#');
      let KeyValuePairArray = [];
      for (let i = 0; i < Math.max(valuesArray.length, textArray.length); i++) {
        KeyValuePairArray.push({
          text: textArray[i],
          value: valuesArray[i],
        });
      }
      return KeyValuePairArray;
    }

    return [];
  }

  //Determine if a question must be visible or not based in the ruleConditionStructureKeys content
  checkQuestionVisibility1(questionDisposition: QuestionDisposition): boolean {
    let question = questionDisposition.question;
    if (question.ruleConditionStructureKeys) {
      const orConditions = question.ruleConditionStructureKeys.split('|');

      for (let condition of orConditions) {
        const andConditions = condition.split('&');
        const allAndConditionsMet = andConditions.every((cond: string) =>
          this.checkCondition(cond),
        );
        if (allAndConditionsMet) {
          if (
            questionDisposition.visible &&
            questionDisposition.question.rfv_RequiredFieldValidatorControl
          ) {
            let controlValidatorArray = this.GetValidators(questionDisposition);
            this.myFormGroup
              .get(questionDisposition.questionId.toString())
              .setValidators(controlValidatorArray);
            this.myFormGroup
              .get(questionDisposition.questionId.toString())
              .updateValueAndValidity();
          }
          return true;
        }
      }
      this.myFormGroup
        .get(questionDisposition.questionId.toString())
        .setValidators([]);
      this.myFormGroup
        .get(questionDisposition.questionId.toString())
        .updateValueAndValidity();

      return false;
    }

    return question.visible || !question.ruleConditionStructureKeys;
  }

  //check a specific condition to determine an specific visibility rule
  checkCondition(condition: string): boolean {
    const [key, value] = condition.split('=');
    return this.responses[key] === value;
  }

  //Handle the selecction in dropdowns and update the answers
  OnSelectDDL(questionDisp, key: string | number, value: any) {
    this.responses[key] = value;
  }

  saveInfoForm(){
    const answers: DynamicFormAnswer[] = [];

    this.dynamicForm.sectionsDisposition[0].section.questionsDisposition.forEach(
      (questionDisposition: QuestionDisposition) => {
        if (this.isVisible(questionDisposition.questionId)) {
          answers.push(this.getAnswers(questionDisposition));
        }
      },
    );

    localStorage.setItem('Answers_' + this.claimOperationId,JSON.stringify(answers));
  }

  loadInfoForm() {
    //console.log("patata")
    const answersStorage = localStorage.getItem(
      'Answers_' + this.claimOperationId
    );
    if (answersStorage) {
      const answers: DynamicFormAnswer[] = JSON.parse(answersStorage);

      answers.forEach((answer) => {
        const control = this.myFormGroup.get(
          answer.QuestionId.toString()
        );

        if (control) {
          control.setValue(answer.Value);
        }
      });
    }
  }

  getAnswers(questionDisposition){

    let formAnswer = new DynamicFormAnswer();

    formAnswer.QuestionId = questionDisposition.questionId;
    formAnswer.KeyName = questionDisposition.question.keyName;
    formAnswer.DynamicForms_Code = this.dynamicForm_Code;
    formAnswer.ExternalId = this.claimOperationId;
    formAnswer.DynamicFormId = +this.dynamicFormId; // el + convierte en entero el valor
    formAnswer.UserID = +this.tokenData.id;
    formAnswer.BitABit = false;
    formAnswer.LastUpdate = new Date();
    formAnswer.LastUpdateBy = this.tokenData.name;
    formAnswer.CreatedBy = this.tokenData.name;

    let formAnswerValue = this.myFormGroup.get(
      questionDisposition.questionId.toString(),
    ).value;
    let controlType = questionDisposition.question.controlTypeName;
    if (
      controlType.toLowerCase() ==
      'Questions_TextBoxNumeric'.toLowerCase()
    ) {
      // si es un numero lo tenemos que procesar
      let valueTo100 = Math.trunc(parseFloat(formAnswerValue) * 100);
      formAnswer.ValueString = valueTo100 + '';
      formAnswer.ValueInt = valueTo100;
    } else if (
      controlType.toLowerCase() == 'Questions_RadDatePicker'.toLowerCase()
    ) {
      formAnswer.Value = formAnswerValue.toString();
      formAnswer.ValueString = formAnswerValue.toString();
    } else if (
      controlType.toLowerCase() ==
        'Questions_DropdownList'.toLowerCase() ||
      controlType.toLowerCase() == 'Questions_Radio'.toLowerCase()
    ) {
      formAnswer.Value = formAnswerValue.toString();
      formAnswer.ValueString = formAnswerValue.toString();
    } else {
      formAnswer.Value = formAnswerValue.toString();
      formAnswer.ValueString = formAnswerValue.toString();
    }
    return formAnswer;

  }

  // lanza el evento de aceptar el formulario y continua el proceso
  onCommitResponses(continueWODoc: boolean = false) {
    this.showErrorConfirm = false;
    this.showRequiredDocuments = false;
    // revisamos si están todos los documentos seleccionados
    const isUploadedIfRequired = (value: RequiredDocuments) =>
      value.uploaded || !value.required;
    let boolRequiredDocumentsAreSelected = true;
    if (this.documentsRequired) {
      boolRequiredDocumentsAreSelected =
        this.requiredDocuments.every(isUploadedIfRequired);
    }

    // revisar si el form es válido y sino mostrar lo que falta
    if (!this.myFormGroup.valid /* || !boolRequiredDocumentsAreSelected */) {
      //console.log('onSaveResponses not valid');
      this.myFormGroup.markAllAsTouched();
      const firstInvalidControl: HTMLElement =
        this.el.nativeElement.querySelector('form .ng-invalid');
      if (firstInvalidControl) {
        firstInvalidControl.focus();
      }

      this.showErrorValidation = true;
      return;
    }

    if (!continueWODoc && !boolRequiredDocumentsAreSelected) {

        const modalElement = document.getElementById('missingFilesGoOn');

        if (modalElement) {

            modalElement.style.zIndex = '99999';

            const modal = new bootstrap.Modal(modalElement, {
                backdrop: false,
                keyboard: false
            });

            modal.show();
        }

        return;
    }
  
    this.showErrorValidation = false;

    this.blockButton = true;

    // si está todo correcto preparamos los parametros del form
    this.formData = new FormData();
    this.requiredDocuments.map((requireDocument) => {
      if (requireDocument.uploaded) {
        this.formData.append('files', JSON.stringify(requireDocument));
      }
    });
    this.formData.append('fileRefs', JSON.stringify(this.fileRefs));
    this.formData.append('claimOperations', this.claimOperationId);
    this.formData.append('stateId', this.finalStateDyf.toString());
    this.formData.append('comments', this.comments);

    // recorremos las preguntas, las que están visibles se meten en las respuestas a enviar
    let formAnswers: DynamicFormAnswer[] = [];
    this.dynamicForm.sectionsDisposition[0].section.questionsDisposition.forEach(
      (questionDisposition: QuestionDisposition) => {
        if (this.isVisible(questionDisposition.questionId)) {
          formAnswers.push(this.getAnswers(questionDisposition));
        }
       },
    );
    this.formData.append('dyfForm', JSON.stringify(formAnswers));

    // llamamos al endpoint con los datos
    this.DynamicFormService.postItem(this.formData).subscribe({
      next: (confirmation) => {
        this.confirmTransitionResponse = confirmation;
        // console.log(this.confirmTransitionResponse);
        // console.log(confirmation);
      },
      error: (response) => {
        this.showErrorConfirm = true;
        if (response.status == 409) {
          // error de información
          //response.error;
          this.listErrorConfirm = [];
          let confirmResponseObject =
            response.error as ConfirmTransitionResponse;
          confirmResponseObject.listFileError.map((fileError) => {
            this.listErrorConfirm.push(
              this.langService
                .translate(fileError.errorMsg)
                .replace('{0}', fileError.fileName),
            );
          });
          confirmResponseObject.claimOperationPermissionsError.map(
            (permissionError) => {
              this.listErrorConfirm.push(
                this.langService
                  .translate(permissionError.errorMsg)
                  .replace('{0}', permissionError.claimOperationId.toString()),
              );
            },
          );
          confirmResponseObject.claimOperationProcessingError.map(
            (processingError) => {
              this.listErrorConfirm.push(
                this.langService
                  .translate(processingError.errorMsg)
                  .replace('{0}', processingError.claimOperationId.toString()),
              );
            },
          );
          if (this.listErrorConfirm.length == 0) {
            let errorMessage = '';
            if (
              confirmResponseObject.hasOwnProperty('logId') &&
              confirmResponseObject.logId
            ) {
              errorMessage = confirmResponseObject.logId.toString();
            }
            this.listErrorConfirm.push(
              this.langService
                .translate('@@CMP.Error_Server')
                .replace('{0}', errorMessage),
            );
          }
        } else if (response.status == 500) {
          let errorMessage = '';
          if (response.error.hasOwnProperty('detail')) {
            errorMessage = response.error['detail'];
          }
          // error de servidor
          this.listErrorConfirm.push(
            this.langService
              .translate('@@CMP.Error_Server')
              .replace('{0}', errorMessage),
          );
        } else {
          // error no identificado
          let errorMessage = '';
          if (response.error.hasOwnProperty('detail')) {
            errorMessage = response.error['detail'];
          }
          this.listErrorConfirm.push(
            this.langService
              .translate('@@CMP.Error_Undefined')
              .replace('{0}', errorMessage),
          );
        }
        this.blockButton = false;
        // console.log('Error Fetchig Contact Data: ', error);
      },
      complete() {
        localStorage.removeItem('Answers_' + this.claimOperationId);
        localStorage.removeItem('Documents_'+this.claimOperationId);
        window.location.reload();
      },
    });
  }

  onSaveResponses() {
    this.showErrorConfirm = false;
    this.showRequiredDocuments = false;
    if (!this.myFormGroup.valid) {
      //console.log('onSaveResponses not valid');
      this.myFormGroup.markAllAsTouched();
      this.showErrorValidation = true;
      const firstInvalidControl: HTMLElement =
        this.el.nativeElement.querySelector('form .ng-invalid');
      firstInvalidControl.focus();
      return;
    }

    this.showErrorValidation = false;

    this.blockButton = true;
    const answerKeys = Object.keys(this.responses);
    const answerValues = Object.values(this.responses);
    const dFKeys = Object.keys(this.dynamicForm['questions']);
    const dFValues = Object.values(this.dynamicForm['questions']);
    //console.log(dFKeys);
    //console.log(dFValues);
    for (let i = 0; i < answerKeys.length; i++) {
      this.dynamicFormAnswers[i] = new DynamicFormAnswer();
      this.dynamicFormAnswers[i].AnswerId = 0;
      this.dynamicFormAnswers[i].PortalId = -1;
      for (let z = 0; z < dFKeys.length; z++) {
        if (dFValues[z] == answerKeys[i]) {
          this.dynamicFormAnswers[i].QuestionId = +dFKeys[z];
          this.dynamicFormAnswers[i].KeyName = String(
            dFValues[z],
          ).toUpperCase();
        }
      }
      for (
        let x = 0;
        x <
        this.dynamicForm['sectionsDisposition'][0]['section'][
          'questionsDisposition'
        ].length;
        x++
      ) {
        if (
          this.dynamicForm['sectionsDisposition'][0]['section'][
            'questionsDisposition'
          ][x]['question']['questionID'] ==
          this.dynamicFormAnswers[i].QuestionId
        ) {
          if (
            this.dynamicForm['sectionsDisposition'][0]['section'][
              'questionsDisposition'
            ][x]['question']['controlTypeName'] == 'Questions_DropdownList' ||
            this.dynamicForm['sectionsDisposition'][0]['section'][
              'questionsDisposition'
            ][x]['question']['controlTypeName'] ==
              'Questions_DropdownList_Dynamic' ||
            this.dynamicForm['sectionsDisposition'][0]['section'][
              'questionsDisposition'
            ][x]['question']['controlTypeName'] == 'Questions_Radio'
          ) {
            this.dynamicFormAnswers[i].Value = answerValues[i] + '';
          } else if (
            this.dynamicForm['sectionsDisposition'][0]['section'][
              'questionsDisposition'
            ][x]['question']['controlTypeName'] == 'Questions_TextBoxNumeric'
          ) {
            // Si es un control de tipo numerico obtenemos el valor y multiplicamos *100 para quitar decimales
            // en el backend dividiremos por 100
            let valueTo100 = Math.trunc(parseFloat(answerValues[i]) * 100);
            this.dynamicFormAnswers[i].ValueString = valueTo100 + '';
            this.dynamicFormAnswers[i].ValueInt = valueTo100;
          } else {
            this.dynamicFormAnswers[i].ValueString = answerValues[i] + '';
          }
        }
      }

      this.dynamicFormAnswers[i].DynamicForms_Code = this.dynamicForm_Code;
      this.dynamicFormAnswers[i].ExternalId = this.claimOperationId;
      this.dynamicFormAnswers[i].DynamicFormId = +this.dynamicFormId;
      this.dynamicFormAnswers[i].UserID = +this.tokenData.id;
      this.dynamicFormAnswers[i].BitABit = false;
      this.dynamicFormAnswers[i].LastUpdate = new Date();
      this.dynamicFormAnswers[i].LastUpdateBy = this.tokenData.name;
      this.dynamicFormAnswers[i].CreatedBy = this.tokenData.name;
      //console.log(this.dynamicFormAnswers);
    }

    this.comprobation = undefined;

    this.formData = new FormData();
    this.formData.append('dyfForm', JSON.stringify(this.dynamicFormAnswers));
    this.formData.append('fileRefs', JSON.stringify(this.fileRefs));
    this.formData.append('claimOperations', this.claimOperationId);
    this.formData.append('stateId', this.finalStateDyf.toString());
    this.formData.append('comments', this.comments);

    //
    const isUploaded = (value: RequiredDocuments) => value.uploaded;
    this.comprobation = this.requiredDocuments.every(isUploaded);
    if (this.comprobation) {
      this.requiredDocuments.map((requireDocument) => {
        this.formData.append('files', JSON.stringify(requireDocument));
      });
      //this.formData.append('files', JSON.stringify(this.documentAssignFileBase64));
      // console.log('se hace transicion');
      this.DynamicFormService.postItem(this.formData).subscribe({
        next: (confirmation) => {
          this.confirmTransitionResponse = confirmation;
          // console.log(this.confirmTransitionResponse);
          // console.log(confirmation);
        },
        error: (response) => {
          this.showErrorConfirm = true;
          if (response.status == 409) {
            // error de información
            //response.error;
            this.listErrorConfirm = [];
            let confirmResponseObject =
              response.error as ConfirmTransitionResponse;
            confirmResponseObject.listFileError.map((fileError) => {
              this.listErrorConfirm.push(
                this.langService
                  .translate(fileError.errorMsg)
                  .replace('{0}', fileError.fileName),
              );
            });
            confirmResponseObject.claimOperationPermissionsError.map(
              (permissionError) => {
                this.listErrorConfirm.push(
                  this.langService
                    .translate(permissionError.errorMsg)
                    .replace(
                      '{0}',
                      permissionError.claimOperationId.toString(),
                    ),
                );
              },
            );
            confirmResponseObject.claimOperationProcessingError.map(
              (processingError) => {
                this.listErrorConfirm.push(
                  this.langService
                    .translate(processingError.errorMsg)
                    .replace(
                      '{0}',
                      processingError.claimOperationId.toString(),
                    ),
                );
              },
            );
            if (this.listErrorConfirm.length == 0) {
              let errorMessage = '';
              if (
                confirmResponseObject.hasOwnProperty('logId') &&
                confirmResponseObject.logId
              ) {
                errorMessage = confirmResponseObject.logId.toString();
              }
              this.listErrorConfirm.push(
                this.langService
                  .translate('@@CMP.Error_Server')
                  .replace('{0}', errorMessage),
              );
            }
          } else if (response.status == 500) {
            let errorMessage = '';
            if (response.error.hasOwnProperty('detail')) {
              errorMessage = response.error['detail'];
            }
            // error de servidor
            this.listErrorConfirm.push(
              this.langService
                .translate('@@CMP.Error_Server')
                .replace('{0}', errorMessage),
            );
          } else {
            // error no identificado
            let errorMessage = '';
            if (response.error.hasOwnProperty('detail')) {
              errorMessage = response.error['detail'];
            }
            this.listErrorConfirm.push(
              this.langService
                .translate('@@CMP.Error_Undefined')
                .replace('{0}', errorMessage),
            );
          }
          this.blockButton = false;
          // console.log('Error Fetchig Contact Data: ', error);
        },
        complete() {
          window.location.reload();
        },
      });
      //let myModal = new bootstrap.Modal('#confirmTransition');
      //  myModal.show();
    } else {
      this.blockButton = false;
      this.showRequiredDocuments = true;
      // let myModal = new bootstrap.Modal('#missingFiles');
      // myModal.show();
    }
  }

  // cierra el modal sin lanzar el proceso
  confirmDisputeAct() {
    if (this.confirmDisputP == false) {
      this.confirmDisputP = true;
      this.confirmDisputeEvent.emit(this.confirmDisputP);
    } else {
      this.confirmDisputP = false;
      this.confirmDisputeEvent.emit(this.confirmDisputP);
    }
  }

  //Método para realizar la traducción del DYF

  dynamicTranslateDYF(dynamicForm: any) {
    // console.log(dynamicForm);
    //Se sustituye el campo del objeto que devuelve el enpoint y que alimenta después al título del formulario por el Group+id de la traducción
    if (dynamicForm.tittle == 'Formulario Respuesta Disputa(Representación)') {
      dynamicForm.tittle = 'DCO.DynamicForm_StartRepresentationTitle';
    }
    //Se recorre el objeto de las preguntas que devuelve el endpoint
    for (
      let i = 0;
      i <
      dynamicForm.sectionsDisposition[0].section.questionsDisposition.length;
      i++
    ) {
      //Se sustituye el campo original del objeto que devuelve el endpoint por el group+id de la traducción
      if (
        dynamicForm.sectionsDisposition[0].section.questionsDisposition[i]
          .question.keyName.length > 0 &&
        !dynamicForm.sectionsDisposition[0].section.questionsDisposition[
          i
        ].question.lbl_LabelText.startsWith('@@')
      ) {
        dynamicForm.sectionsDisposition[0].section.questionsDisposition[
          i
        ].question.lbl_LabelText =
          'DCO.DynamicForm_' +
          dynamicForm.sectionsDisposition[0].section.questionsDisposition[
            i
          ].question.keyName.replace('.', '');
      }
    }
  }

  refresh(): void {
    // window.location.reload();
  }
}
